import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "suggestions", "suggestionItem"]
  static values = {
    adminsByEntity: Object
  }

  connect() {
    this.hideDropdown()
  }

  search(event) {
    const query = event.target.value.toLowerCase().trim()

    if (query.length === 0) {
      this.hideDropdown()
      return
    }

    const matches = this.findMatches(query)
    this.displaySuggestions(matches, query)
  }

  findMatches(query) {
    const matches = []

    for (const [entityTitle, admins] of Object.entries(this.adminsByEntityValue)) {
      if (entityTitle.toLowerCase().includes(query)) {
        // Find the admin with @fanword.com email
        const fanwordAdmin = admins.find(admin => admin[1].includes('@fanword.com'))
        if (fanwordAdmin) {
          matches.push({
            entityTitle: entityTitle,
            adminTitle: fanwordAdmin[0],
            adminId: fanwordAdmin[2]
          })
        }
      }
    }

    return matches.slice(0, 10) // Limit to 10 results
  }

  displaySuggestions(matches, query) {
    this.suggestionsTarget.innerHTML = ''

    if (matches.length === 0) {
      const noResults = document.createElement('div')
      noResults.className = 'p-2 text-muted text-center'
      noResults.textContent = `No customers found matching "${query}"`
      this.suggestionsTarget.appendChild(noResults)
      this.showDropdown()
      return
    }

    matches.forEach((match, index) => {
      const item = document.createElement('div')
      item.className = 'p-2'
      item.style.cursor = 'pointer'
      item.textContent = match.entityTitle
      item.dataset.adminId = match.adminId
      item.dataset.action = 'click->anylogin-search#selectEntity mouseenter->anylogin-search#highlightItem mouseleave->anylogin-search#unhighlightItem'
      this.suggestionsTarget.appendChild(item)

      // Add separator between items except for the last one
      if (index < matches.length - 1) {
        const separator = document.createElement('hr')
        separator.className = 'my-0'
        this.suggestionsTarget.appendChild(separator)
      }
    })

    this.showDropdown()
  }

  highlightItem(event) {
    event.currentTarget.style.backgroundColor = '#f8f9fa'
  }

  unhighlightItem(event) {
    event.currentTarget.style.backgroundColor = 'transparent'
  }

  selectEntity(event) {
    const adminId = event.currentTarget.dataset.adminId

    // Find the AnyLogin select element and set its value
    const anyLoginSelect = document.querySelector('#any_login_box #selected_id')
    if (anyLoginSelect) {
      anyLoginSelect.value = adminId

      // Trigger the change event to make AnyLogin process the selection
      const changeEvent = new Event('change', { bubbles: true })
      anyLoginSelect.dispatchEvent(changeEvent)

      // If AnyLogin is set to login on button click, click the button
      const anyLoginButton = document.querySelector('.any_login input[type="submit"]')
      if (anyLoginButton) {
        anyLoginButton.click()
      }
    }

    this.hideDropdown()
    this.inputTarget.value = ''
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideDropdown()
    }
  }

  showDropdown() {
    this.suggestionsTarget.classList.remove('d-none')
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  hideDropdown() {
    this.suggestionsTarget.classList.add('d-none')
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  handleKeydown(event) {
    // Handle escape key to close dropdown
    if (event.key === 'Escape') {
      this.hideDropdown()
      this.inputTarget.value = ''
      this.inputTarget.blur()
    }
  }
}
